// Implements: F-SHR-006
/**
 * Mockup v3 P8: the four expiry choices of the v3 mockup as `<option>`s ("7 días", "30 días",
 * "90 días", "1 año"), after the caller's own first option (the server's default on a
 * creation, "Sin cambios" on an edit). Each value is the choice spelled out (`"7"`, `"never"`), which
 * `expiryChoiceOf` reads back.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { EXPIRY_CHOICES } from "../model/expiryDays";

export function ExpiryOptions(): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      {EXPIRY_CHOICES.map((choice) => (
        <option key={choice} value={String(choice)}>
          {choice === "never" ? t("sharing.expiry.never") : t("sharing.expiry.days", { n: choice })}
        </option>
      ))}
    </>
  );
}
